import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/atendimento-medico`

    const headers = { responseType: "arraybuffer" }

    return {
        atestadoAcompanhante(atendimentoId, queryParms = {}) {

            return atendimentoId
                ? repository.get(`${baseUrl}/atestado-acompanhante/${atendimentoId}`, headers)
                : repository.get(`${baseUrl}/atestado-acompanhante?${urlUtil.serialize(queryParms)}`, headers)
        },
        atestado(atendimentoId, queryParms = {}) {

            return atendimentoId
                ? repository.get(`${baseUrl}/atestado/${atendimentoId}`, headers)
                : repository.get(`${baseUrl}/atestado?${urlUtil.serialize(queryParms)}`, headers)
        },
        declaracaoComparecimentoAcompanhante(atendimentoId, queryParms = {}) {

            return atendimentoId
                ? repository.get(`${baseUrl}/declaracao-comparecimento-acompanhante/${atendimentoId}`, headers)
                : repository.get(`${baseUrl}/declaracao-comparecimento-acompanhante?${urlUtil.serialize(queryParms)}`, headers)
        },
        declaracaoComparecimentoPaciente(atendimentoId, queryParms = {}) {

            return atendimentoId
                ? repository.get(`${baseUrl}/declaracao-comparecimento-paciente/${atendimentoId}`, headers)
                : repository.get(`${baseUrl}/declaracao-comparecimento-paciente?${urlUtil.serialize(queryParms)}`, headers)
        },
        encaminhamentoHospitalar(atendimentoId) {

            return repository.get(`${baseUrl}/${atendimentoId}/encaminhamento-hospitalar`, headers)
        },
        solicitacaoExamesImagem(atendimentoId) {

            return repository.get(`${baseUrl}/${atendimentoId}/solicitacao-exames-imagem`, headers)
        },
        solicitacaoExamesLaboratoriais(atendimentoId) {

            return repository.get(`${baseUrl}/${atendimentoId}/solicitacao-exames-laboratoriais`, headers)
        },
        guiaEncaminhamento(atendimentoId, queryParms = {}) {

            return atendimentoId
                ? repository.get(`${baseUrl}/guia-encaminhamento/${atendimentoId}`, headers)
                : repository.get(`${baseUrl}/guia-encaminhamento?${urlUtil.serialize(queryParms)}`, headers)
        },
        orientacoes(atendimentoId, queryParms = {}) {

            return atendimentoId
                ? repository.get(`${baseUrl}/orientacoes/${atendimentoId}`, headers)
                : repository.get(`${baseUrl}/orientacoes?${urlUtil.serialize(queryParms)}`, headers)
        },
        prescricaoInterna(atendimentoId, queryParms = {}) {

            return atendimentoId
                ? repository.get(`${baseUrl}/prescricao-interna/${atendimentoId}?${urlUtil.serialize(queryParms)}`, headers)
                : repository.get(`${baseUrl}/prescricao-interna?${urlUtil.serialize(queryParms)}`, headers)
        },
        receita(atendimentoId, queryParms = {}) {

            return atendimentoId
                ? repository.get(`${baseUrl}/receita/${atendimentoId}?${urlUtil.serialize(queryParms)}`, headers)
                : repository.get(`${baseUrl}/receita?${urlUtil.serialize(queryParms)}`, headers)
        },
        receitaEspecial(atendimentoId, queryParms = {}) {

            return atendimentoId
                ? repository.get(`${baseUrl}/receita-especial/${atendimentoId}?${urlUtil.serialize(queryParms)}`, headers)
                : repository.get(`${baseUrl}/receita-especial?${urlUtil.serialize(queryParms)}`, headers)
        },
        laudoMedicamentos(atendimentoId, queryParms = {}) {

            return atendimentoId
                ? repository.get(`${baseUrl}/laudo-medicamento/${atendimentoId}?${urlUtil.serialize(queryParms)}`, headers)
                : repository.get(`${baseUrl}/laudo-medicamento?${urlUtil.serialize(queryParms)}`, headers)
        },
        servicoEnfermagem(atendimentoId) {

            return repository.get(`${baseUrl}/${atendimentoId}/servico-enfermagem`, headers)
        },
    }
}
